import { createAsyncThunk } from '@reduxjs/toolkit';
import ApiService from '../../../infrastructure/services/api/services';
import { apiConfig } from '../../../application/configurations/apiConfig';
import { ApiConfig } from '../../../application/configurations/IConfig';
import { UserModel } from '../../../application/model/user/model';
import { homeConfigurations } from './config';
import { AuthService } from '../../../infrastructure/services/authentication/auth';
import { loginRequest } from '../../../application/configurations/authConfig';
import { store } from '../../../application/store';
import { setLoginAccessToken } from '../../../application/store/commonReducer';
import envConfig from '../../../application/configurations/envConfig';

class UserInfo {
  private graphApiConfig: ApiConfig;

  constructor() { 
    this.graphApiConfig = { ...apiConfig.getUserExtensionProperties };
  }

/*
* async method to get the user profile properties from GraphAPI
*/
  getUserInfo = createAsyncThunk('GraphAPI', async () => {
    let selectedProperties: string = homeConfigurations.profileSelectProperties;   
    const graphApiConfig = { ...this.graphApiConfig };
    graphApiConfig.endpoint = graphApiConfig.endpoint + selectedProperties;
    let result: any;
    await ApiService.requestApi([graphApiConfig]).then(
      (response: { [key: string]: any }) => {
        const UserResponseModel = new UserModel(response[0]);
        result = UserResponseModel.userData;
      },
      (error) => {
        console.log(error);
      }
    );

    return {
      results : result[0]
    }
  
  });

  loginAccessToken = (accounts: any) => {
    AuthService(accounts, [envConfig.aemScope]).then((response: any) => {
      store.dispatch(setLoginAccessToken(response.accessToken));
    })
      .catch(() => {
        ApiService.tokenErrorHandler();
      });
}
}
const UserInfoUseCase = new UserInfo();
export default UserInfoUseCase;
